import { Injectable } from '@angular/core';
import { BusinessesFilter } from './businesses-filter';

@Injectable({
  providedIn: 'root',
})
export class BusinessesFilterService {
  filter: BusinessesFilter;

  clear() {
    this.filter = new BusinessesFilter();
  }
}
